module.exports = __webpack_public_path__ + "static/media/ico-play.df754eb5.svg";